import React, { useState, useEffect } from 'react'
import CustomAlert from '../../shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import { MDBContainer, MDBBtn, MDBRow, MDBCol, MDBBreadcrumb, MDBBreadcrumbItem } from 'mdb-react-ui-kit'
import { UIDatePickerInput } from './../../forms/form-fields'
import { toast } from 'react-toastify'
import UserProfileService from './../../../shared/services/UserProfile.service'
import moment from 'moment'
import TextEditor from '../../shared/TextEditor/TextEditor.component'
import Store from './../Messaging.store'

import './MessageForm.scss'

const effecitveMinDate = new Date(2000, 0, 1),
  effectiveMaxDate = moment().add(3, 'years').toDate(),
  timezoneOffset = new Date().getTimezoneOffset()

const MessageForm = ({ category }) => {
  const Message = Store.Message[category],
    userId = UserProfileService.getUserId(),
    { checkUserCanModify, canUpdate, canDelete, onSubmit, onDelete, errors, isSaving, isDeleting } = Store,
    isFetching = Store.isFetching[category],
    categories = [category].map(c => (
      <option key={c} value={c}>
        {(' ' + c).replace(/ [\w]/g, a => a.toLocaleUpperCase()).trim()}
      </option>
    ))

  const goToList = () => {}

  const renderErrorField = field => {
    if (field && errors.hasOwnProperty(field)) return <span className='error-msg'>{errors[field]}</span>
    return <></>
  }

  const onChange = event => {
    if (Message) Message.set(event.target.name, event.target.value)
  }

  useEffect(() => {
    checkUserCanModify()
  }, [userId])

  return (
    <MDBContainer id='MessageFormComponent' fluid>
      <MDBBreadcrumb>
        <MDBBreadcrumbItem
          onClick={() => {
            if (isFetching || isSaving || isDeleting) return

            window.history.pushState({}, '', window.location.pathname)
            Store.Message[category] = null
          }}
        >
          Back to Message List
        </MDBBreadcrumbItem>
      </MDBBreadcrumb>
      {isFetching || !Message ? (
        <h4 className='p4'>Loading...</h4>
      ) : (
        <MDBRow>
          <MDBCol size='12' md='6'>
            <form>
              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <label className='grey-text' htmlFor='d_name'>
                    Title
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    name='msgTitle'
                    id='msgTitle'
                    value={Message.get('title')}
                    readOnly={!!Message.get('deleted_at')}
                    onChange={event => Message.set('title', event.target.value)}
                  />
                  {renderErrorField('msgTitle')}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <label className='grey-text' htmlFor='d_name'>
                    Category
                  </label>
                  <select
                    className='browser-default custom-select form-control'
                    name='msgCategory'
                    id='msgCategory'
                    value={Message.get('category')}
                    readOnly={!!Message.get('deleted_at') || categories.length < 2}
                    onChange={event => Message.set('category', event.target.value)}
                  >
                    {categories}
                  </select>
                  {renderErrorField('msgCategory')}
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <UIDatePickerInput
                    label='Start Date'
                    name='msg_start_date'
                    id='dp_msg_start_date'
                    showYearDropdown
                    yearDropdownItemNumber={2}
                    scrollableYearDropdown
                    dateFormat='MM/dd/yyyy'
                    selected={
                      Message.get('start_date')
                        ? new Date(new Date(Message.get('start_date')).getTime() + timezoneOffset * 60000)
                        : null
                    }
                    onChange={date => Message.set('start_date', date.target.value)}
                    readOnly={!!Message.get('deleted_at')}
                    minDate={effecitveMinDate}
                    maxDate={effectiveMaxDate}
                  />
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col-md-12'>
                  <UIDatePickerInput
                    label='End Date'
                    name='msg_end_date'
                    id='dp_msg_end_date'
                    showYearDropdown
                    yearDropdownItemNumber={2}
                    scrollableYearDropdown
                    dateFormat='MM/dd/yyyy'
                    selected={
                      Message.get('end_date')
                        ? new Date(new Date(Message.get('end_date')).getTime() + timezoneOffset * 60000)
                        : null
                    }
                    onChange={date => Message.set('end_date', date.target.value)}
                    readOnly={!!Message.get('deleted_at')}
                    minDate={effecitveMinDate}
                    maxDate={effectiveMaxDate}
                  />
                  <small className='text-left helper-link grey-text'>
                    Messages will be visible for 7 days by default, or until the end date indicated.
                  </small>
                </div>
              </div>
              <div className='form-row mt-2'>
                <div className='form-group col-md-12'>
                  <label className='grey-text'>Content</label>
                  {!Message.get('deleted_at') ? (
                    <TextEditor
                      id='messageForm'
                      value={Message.get('content')}
                      onChange={html => Message.set('content', html)}
                    />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: Message.get('content'),
                      }}
                    ></div>
                  )}
                  {renderErrorField('msgContent')}
                </div>
              </div>

              <div className='form-row text-center mt-4 d-flex flex-wrap gap-2'>
                {Message.get('deleted_at') && (
                  <CustomAlert color='danger'>
                    This message was deleted on{' '}
                    {moment.utc(Message.get('deleted_at')).local().format('MM/DD/YYYY h:mm a')}.
                  </CustomAlert>
                )}
                {canUpdate && !Message.get('deleted_at') && (
                  <MDBBtn
                    color='unique'
                    type='button'
                    disabled={isFetching || isSaving || isDeleting}
                    onClick={async () => {
                      if (onSubmit(category)) {
                        toast.success('Message saved.', {
                          position: toast.POSITION.TOP_RIGHT,
                        })
                        return true
                      }

                      toast.error(
                        'Oh no! Errors exist.  Please check your inputs before attempting to save the message.',
                        { position: toast.POSITION.TOP_RIGHT }
                      )
                    }}
                  >
                    {isSaving ? 'Saving...' : 'Save'}
                  </MDBBtn>
                )}
                {canUpdate && !Message.isNew() && !Message.get('deleted_at') && (
                  <MDBBtn
                    color='danger'
                    type='button'
                    disabled={isFetching || isSaving || isDeleting}
                    onClick={() => {
                      onDelete(category)
                    }}
                  >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                  </MDBBtn>
                )}
              </div>
            </form>
          </MDBCol>
        </MDBRow>
      )}
    </MDBContainer>
  )
}

export default observer(MessageForm)
